import Vue from 'vue'
import Vuex from 'vuex'

import cover from './modules/cover'
import about from './modules/about'
import projects from './modules/projects'
import contact from './modules/contact'

Vue.use(Vuex)

export default new Vuex.Store({

  modules: {
    cover,
    about,
    projects,
    contact
  },

  state: {
    app: {
      loading: true
    }
  },
  mutations: {
    setLoading(state, loading) {
      if (loading) {
        state.app.loading = loading        
      } else {
        setTimeout(() => {
          state.app.loading = loading
        }, 10)
      }
    }
  },
  actions: {
  }
})
